import { render, staticRenderFns } from "./actividades-proyecto.vue?vue&type=template&id=23837e2e"
import script from "./actividades-proyecto.vue?vue&type=script&lang=js"
export * from "./actividades-proyecto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports